import { render, staticRenderFns } from "./SingleNumberFrameMobiles.vue?vue&type=template&id=3c6d9038&"
import script from "./SingleNumberFrameMobiles.vue?vue&type=script&lang=js&"
export * from "./SingleNumberFrameMobiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports